/* bis-js-v10 */
(function () {
  function parseProductJson(raw) {
    if (!raw) {
      return null;
    }

    try {
      return JSON.parse(raw);
    } catch (error) {
      return null;
    }
  }

  function normalizeBisProduct(product) {
    if (!product) {
      return null;
    }

    return {
      id: product.id,
      handle: product.handle,
      tags: product.tags || [],
      available: false,
      variants: (product.variants || []).map(function (variant) {
        return {
          id: variant.id,
          title: variant.title || variant.public_title || variant.name || 'Default Title',
          available: false,
          inventory_quantity: typeof variant.inventory_quantity === 'number' ? variant.inventory_quantity : 0,
          inventory_management: variant.inventory_management || 'shopify'
        };
      })
    };
  }

  function isProtectedBisButton(el) {
    if (!el || el.nodeType !== 1) {
      return false;
    }

    if (el.classList.contains('bis-pdp-button') || el.classList.contains('bis-collection-button')) {
      return true;
    }

    return !!el.closest('.product-item');
  }

  function bisDefer(callback) {
    if (window.BIS && typeof window.BIS.defer === 'function') {
      window.BIS.defer(13, callback);
      return;
    }

    window.setTimeout(callback, 50);
  }

  function getProductFromTrigger(trigger) {
    var productForm = trigger.closest('.product-form');
    var product = null;
    var handle = trigger.getAttribute('data-product-handle');
    var variantId = trigger.getAttribute('data-variant-id');

    product = normalizeBisProduct(parseProductJson(trigger.getAttribute('data-product-data')));
    handle = handle || (product && product.handle);

    if (!product && productForm) {
      var jsonEl = productForm.querySelector('.bis-pdp-product-json');

      if (jsonEl) {
        product = normalizeBisProduct(parseProductJson(jsonEl.textContent));
        handle = handle || (product && product.handle);
      }
    }

    if (!product && productForm) {
      var bisData = productForm.querySelector('.product-form__bis-data');

      if (bisData) {
        product = normalizeBisProduct(parseProductJson(bisData.getAttribute('data-product-data')));
        handle = handle || bisData.getAttribute('data-product-handle') || (product && product.handle);
        variantId = variantId || bisData.getAttribute('data-variant-id');
      }
    }

    if (!product) {
      var item = trigger.closest('.product-item');
      if (item) {
        var raw =
          item.getAttribute('data-bis-product') ||
          (item.querySelector('.product-item__bis-data') &&
            item.querySelector('.product-item__bis-data').getAttribute('data-product-data'));
        product = normalizeBisProduct(parseProductJson(raw));
        handle = handle || (product && product.handle);
      }
    }

    if (!variantId && product && product.variants && product.variants.length) {
      variantId = String(product.variants[0].id);
    }

    if (!product || !handle) {
      return null;
    }

    return { product: product, handle: handle, variantId: variantId };
  }

  function pruneOrphanedBisFrames() {
    window.setTimeout(function () {
      var frames = document.querySelectorAll('#BIS_frame');

      if (frames.length <= 1) {
        return;
      }

      var visibleFrame = null;

      for (var i = 0; i < frames.length; i += 1) {
        if (frames[i].offsetWidth > 0 && window.getComputedStyle(frames[i]).display !== 'none') {
          visibleFrame = frames[i];
          break;
        }
      }

      for (var j = 0; j < frames.length; j += 1) {
        if (frames[j] !== visibleFrame && frames[j].parentNode) {
          frames[j].parentNode.removeChild(frames[j]);
        }
      }
    }, 500);
  }

  function showPopover(payload) {
    if (!window.BIS || !window.BIS.createPopover) {
      return false;
    }

    window.__bisPopovers = window.__bisPopovers || {};

    var popover =
      window.__bisPopovers[payload.handle] ||
      (window.__bisPopovers[payload.handle] = window.BIS.createPopover({
        productHandle: payload.handle,
        product: payload.product,
        button: { visible: false }
      }));

    popover.ready.then(function () {
      bisDefer(function () {
        try {
          popover.form.show({ variantId: payload.variantId });
          pruneOrphanedBisFrames();
        } catch (error) {
          delete window.__bisPopovers[payload.handle];
        }
      });
    });

    return true;
  }

  window.openBisPlpCollection = function (trigger, event) {
    if (!trigger) {
      return false;
    }

    if (event) {
      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();
    }

    var payload = getProductFromTrigger(trigger);
    if (!payload) {
      return false;
    }

    if (showPopover(payload)) {
      return false;
    }

    var attempts = 0;
    var timer = window.setInterval(function () {
      attempts += 1;
      if (showPopover(payload) || attempts > 100) {
        window.clearInterval(timer);
      }
    }, 100);

    return false;
  };

  document.addEventListener(
    'click',
    function (event) {
      var trigger = event.target.closest('.product-item .bis-collection-button, .product-item a.BIS_trigger');

      if (!trigger) {
        return;
      }

      window.openBisPlpCollection(trigger, event);
    },
    true
  );

  window.openBisPdp = window.openBisPlpCollection;

  document.addEventListener(
    'click',
    function (event) {
      var trigger = event.target.closest('.bis-pdp-button, .product-form__payment-container .bis-pdp-button');

      if (!trigger) {
        return;
      }

      window.openBisPlpCollection(trigger, event);
    },
    true
  );

  function isAmpNotifyElement(el) {
    if (!el || el.nodeType !== 1 || isProtectedBisButton(el)) {
      return false;
    }

    return (
      el.id === 'BIS_trigger' ||
      el.classList.contains('BIS_trigger') ||
      el.classList.contains('button--danger') ||
      /email|back\s*in\s*stock|when\s*available|notify/i.test(el.textContent || '')
    );
  }

  function scrubPdpAmpButton() {
    if (!document.querySelector('.product-form__payment-container .bis-pdp-button')) {
      return;
    }

    document.querySelectorAll('#BIS_trigger, .BIS_trigger, button.button--danger, button.button--primary, a.BIS_trigger').forEach(function (el) {
      if (isAmpNotifyElement(el)) {
        el.remove();
      }
    });

    document.querySelectorAll('.product-meta__value-props ~ #BIS_trigger, .product-meta__value-props ~ .BIS_trigger, .product-meta__value-props ~ button, .product-meta__value-props ~ a').forEach(function (el) {
      if (isAmpNotifyElement(el)) {
        el.remove();
      }
    });
  }

  document.addEventListener('DOMContentLoaded', scrubPdpAmpButton);
  document.addEventListener('product:rerender', scrubPdpAmpButton);
  window.addEventListener('load', scrubPdpAmpButton);

  if (typeof MutationObserver !== 'undefined') {
    new MutationObserver(function () {
      scrubPdpAmpButton();
    }).observe(document.body, {
      childList: true,
      subtree: true
    });
  }
})();
